import React from "react";
import { useSpecsPageContext } from "./SpecsPageContext";
import SpecsFormPage from "./specsForm/SpecsFormPage";
import { getSpecsAutoFormSchema } from "./specsForm/autoFormSchemas";

export default function SpecsAutoFormEditor() {
  const {
    specType,
    description,
    emptyMessage,
    draftModel,
    selectedValue,
    validationResult,
    catalog,
  } = useSpecsPageContext();

  const schema = React.useMemo(
    () =>
      getSpecsAutoFormSchema(specType, {
        products: catalog?.products ?? [],
      }),
    [catalog?.products, specType]
  );

  return (
    <SpecsFormPage
      description={description}
      emptyMessage={emptyMessage}
      model={draftModel}
      schema={schema}
      imageUploadContext={{
        specType,
        specName: selectedValue || undefined,
      }}
      validationIssues={validationResult?.valid ? [] : validationResult?.issues}
      validationSpecType={specType}
    />
  );
}
